<template>
    <div>
        <div v-if="isSpinnerShow" class="d-flex justify-content-center mt-3 mb-3">
            <b-spinner label="Loading..."></b-spinner>
        </div>
        <div v-else class="dataTables_wrapper dt-bootstrap4">
            <div class="row" data-spy="scroll" data-target="#itemSP" data-offset="0">
                <div class="col-sm-12 overflow-auto">
                    <table class="table table-sm table-hover table-bordered table-striped w-100 dataTable dtr-inline" role="grid" style="height: 1px">
                        <thead class="thead-themed">
                            <tr>
                                <th v-for="tblHeader in fields" :key="tblHeader.key">{{tblHeader.label}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(items, item, j) in voucherItems" :key="j">
                                <td>{{j+1}}</td>
                                <td>{{item}}</td>
                                <td class="text-center" :class="{'fw-500' : items.signup != 0}">{{items.signup}}</td>
                                <td>{{formatPrice(items.totalSignup)}}</td>
                                <td class="text-center" :class="{'fw-500' : items.redeem != 0}">{{items.redeem}}</td>
                                <td>{{formatPrice(items.totalRedeem)}}</td>
                                <td class="text-center" :class="{'fw-500' : items.expired != 0}">{{items.expired}}</td>
                                <td>{{formatPrice(items.totalExpired)}}</td>
                                <td class="text-center" :class="{'fw-500' : items.balance != 0}">{{items.balance}}</td>
                                <td>{{formatPrice(items.totalBalance)}}</td>
                            </tr>
                            <tr>
                                <td colspan="2" class="border-top-bottom-2 text-right fw-700">{{$t('label.total')}}</td>
                                <td class="text-center border-top-bottom-2 fw-500">{{getTotal('signup')}}</td>
                                <td class="border-top-bottom-2 fw-500">{{formatPrice(getTotal('totalSignup'))}}</td>
                                <td class="text-center border-top-bottom-2 fw-500">{{getTotal('redeem')}}</td>
                                <td class="border-top-bottom-2 fw-500">{{formatPrice(getTotal('totalRedeem'))}}</td>
                                <td class="text-center border-top-bottom-2 fw-500">{{getTotal('expired')}}</td>
                                <td class="border-top-bottom-2 fw-500">{{formatPrice(getTotal('totalExpired'))}}</td>
                                <td class="text-center border-top-bottom-2 fw-500">{{getTotal('balance')}}</td>
                                <td class="border-top-bottom-2 fw-500">{{formatPrice(getTotal('totalBalance'))}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import _ from 'lodash';
import moment from 'moment'
import {setVoucherSummaryItems} from './../../../../assets/js/dashboard/salonReport/salonReport'
import {handleSessionExpired, getOutletName} from './../../../../assets/js/dashboard/dashboard'
import {convertDateToTimestamp, formatPrice, formatDate, dateRange, reorderObject, setDayArrayWithDateRange, setYearsArrayWithDateRange, setYearArrayWithDateRange}
from './../../../../assets/js/dashboard/utilities'
export default {
    name: "voucherSummaryDate",
    data(){
        return{
            isSpinnerShow: false,
            typeItems: ['signup', 'redeem', 'expired', 'balance', 'totalSignup', 'totalRedeem', 'totalExpired', 'totalBalance'],
            voucherItems: {}, 
            filterObj: {},
        }
    },
    computed:{
        fields(){
            return[
                {key: "index", label: "#"},
                {key: "date", label: this.$i18n.t('table.header.date')},
                {key: "signup", label: this.$i18n.t('salon_report.voucher.sign_up')},
                {key: "totalSignup", label: this.$i18n.t('table.header.total', {'item': this.$i18n.t('table.header.amount')})},
                {key: "redeem", label: this.$i18n.t('salon_report.voucher.redeem')},
                {key: "totalRedeem", label: this.$i18n.t('table.header.total', {'item': this.$i18n.t('table.header.amount')})},
                {key: "expired", label: this.$i18n.t('salon_report.voucher.expired')},
                {key: "totalExpired", label: this.$i18n.t('table.header.total', {'item': this.$i18n.t('table.header.amount')})},
                {key: "balance", label: this.$i18n.t('table.header.balance')},
                {key: "totalBalance", label: this.$i18n.t('table.header.total', {'item': this.$i18n.t('table.header.amount')})},
            ]
        },
        exportFields(){
            var ret = {}
            ret["#"] = "index"
            ret[this.$i18n.t('table.header.date').toUpperCase()] = "date"
            ret[this.$i18n.t('salon_report.voucher.sign_up').toUpperCase()] = "signup"
            ret[this.$i18n.t('table.header.total', {'item': this.$i18n.t('table.header.amount')}).toUpperCase()] = "totalSignup"
            ret[this.$i18n.t('salon_report.voucher.redeem').toUpperCase()] = "redeem"
            ret[this.$i18n.t('table.header.total', {'item': this.$i18n.t('table.header.amount')}).toUpperCase()] = "totalRedeem"
            ret[this.$i18n.t('salon_report.voucher.expired').toUpperCase()] = "expired"
            ret[this.$i18n.t('table.header.total', {'item': this.$i18n.t('table.header.amount')}).toUpperCase()] = "totalExpired"
            ret[this.$i18n.t('table.header.balance').toUpperCase()] = "balance"
            ret[this.$i18n.t('table.header.total', {'item': this.$i18n.t('table.header.amount')}).toUpperCase()] = "totalExpired"
            return ret
        }
    },
    watch:{
        "$i18n.locale"(val){
            if(this.$parent.tab == 'date'){
                this.setExportData(this.voucherItems)
            }
        }
    },
    methods:{
        formatPrice(price){
            return formatPrice(price)
        },
        setFormatDate(createDate, redeemDate, expiredDate, startDate, endDate){
            startDate = moment(startDate).unix()
            endDate = moment(endDate).unix()

            var strFormatDate = ""
            if(redeemDate == 0 && expiredDate == 0){
                strFormatDate = formatDate(createDate);
            }else{
                if(expiredDate != 0){
                    strFormatDate = expiredDate >= startDate && expiredDate <= endDate ? formatDate(expiredDate) : formatDate(createDate)
                }else{
                    console.log(redeemDate, startDate, endDate, createDate)
                    strFormatDate = redeemDate >= startDate && redeemDate <= endDate ? formatDate(redeemDate) : formatDate(createDate)
                    console.log("elseee" + strFormatDate)
                }
            }
            
            return strFormatDate
        },
        groupVoucherByMonth(items, startDate, endDate){
            var result = []
            for(var i=0; i<items.length; i++){
                var item = items[i]
                if(item.redeemDate == 0 && item.expiredDate == 0){
                    if(item.purchaseDate >= startDate && item.purchaseDate <= endDate){
                        result.push(item)
                    }
                }else{
                    if(item.expiredDate != 0){
                        if(item.expiredDate >= startDate && item.expiredDate <= endDate){
                            result.push(item)
                        }else{
                            if(item.purchaseDate >= startDate && item.purchaseDate <= endDate){
                                result.push(item)
                            }
                        }
                    }else{
                        if(item.redeemDate >= startDate && item.redeemDate <= endDate){
                            result.push(item)
                        }else{
                            if(item.purchaseDate >= startDate && item.purchaseDate <= endDate){
                                result.push(item)
                            }
                        }
                    }
                }
            }
            return result
        },
        async setVoucherSummary(filterObj){
            this.voucherItems = [];
            this.filterObj = filterObj;
            var dateFilter = "?startTrxnDate=" + moment(filterObj.date.startDate).unix() + "&endTrxnDate=" + moment(filterObj.date.endDate).unix()
            var outletFilter = filterObj.outletID == "all" ? "" : "&outletID=" + filterObj.outletID;

            var searchVoucher = filterObj.searchVoucher == "" ? "" : "&searchVoucher=" + filterObj.searchVoucher
            var searchCustomer = filterObj.searchCustomer == "" ? "" : "&searchMember=" + filterObj.searchCustomer
            var searchFilter = searchVoucher + searchCustomer

            this.isSpinnerShow = true;
            var summary = await this.getVoucherSummary(dateFilter + outletFilter + searchFilter);

            const range = dateRange(moment(filterObj.date.startDate).toDate(), moment(filterObj.date.endDate).toDate());
            if(range.length == 1){
                var rangeArr = range.map(date => moment(date).format(this.$msg.CST.DATE_FORMAT))
                for(var i=0; i<summary.length; i++){
                    summary[i]["formatDate"] = this.setFormatDate(summary[i].purchaseDate, summary[i].redeemDate, summary[i].expiredDate, filterObj.date.startDate, filterObj.date.endDate)
                }

                var group = _.groupBy(summary, "formatDate")

                for(var j=0; j<rangeArr.length; j++){
                    if(!(rangeArr[j] in group)){
                        group[rangeArr[j]] = []
                    }
                }
                var reordered = reorderObject(group)
                var obj = {}
                for(var key in reordered){
                    obj[key] = setVoucherSummaryItems(reordered[key], convertDateToTimestamp(filterObj.date.startDate), convertDateToTimestamp(filterObj.date.endDate))
                }
                this.voucherItems = obj
            }else if(range.length > 1 && range.length < 365){
                var dayRange = setDayArrayWithDateRange(range)
                
                for(var day in dayRange){
                    dayRange[day]["items"] = this.groupVoucherByMonth(summary, dayRange[day].startDate, dayRange[day].endDate);
                }
                var dayObj = {}
                for(var days in dayRange){
                    dayObj[days] = setVoucherSummaryItems(dayRange[days].items, dayRange[days].startDate, dayRange[days].endDate)
                }
                this.voucherItems = dayObj
                
            }else if(range.length == 365 || range.length == 366){
                var yearObj = setYearArrayWithDateRange(moment(filterObj.date.startDate).toDate())

                for(var m=0; m<yearObj.length; m++){
                    yearObj[m]["items"] = this.groupVoucherByMonth(summary, yearObj[m].startDate, yearObj[m].endDate);
                } 
                var yrObj = {}
                for(var l=0; l<yearObj.length; l++){
                    yrObj[yearObj[l].month] = setVoucherSummaryItems(yearObj[l].items, yearObj[l].startDate, yearObj[l].endDate)
                }
                this.voucherItems = yrObj
            }else{
                var yearsObj = setYearsArrayWithDateRange(moment(filterObj.date.startDate).toDate(), moment(filterObj.date.endDate).toDate())
 
                for(var x=0; x<yearsObj.length; x++){
                    var year = _.values(yearsObj[x])
                    for(var y=0; y<year[0].length; y++){
                        year[0][y]["items"] = this.groupVoucherByMonth(summary, year[0][y].startDate, year[0][y].endDate);
                    }
                }
                
                for(var z=0; z<yearsObj.length; z++){
                    var years = _.values(yearsObj[z])
                    for(var a=0; a<years[0].length; a++){
                        years[0][a] = setVoucherSummaryItems(summary, years[0][a].startDate, years[0][a].endDate);
                    }
                }

                var yrsObj = {}
                for(var b=0; b<yearsObj.length; b++){
                    var yrs = _.values(yearsObj[b])
                    var signup = 0; var redeem = 0; var expired = 0;
                    var totalSignup = 0; var totalRedeem = 0; var totalExpired = 0;
                    for(var c=0; c<yrs[0].length; c++){
                        signup += yrs[0][c].signup
                        redeem += yrs[0][c].redeem
                        expired += yrs[0][c].expired
                        totalSignup += yrs[0][c].totalSignup
                        totalRedeem += yrs[0][c].totalRedeem
                        totalExpired += yrs[0][c].totalExpired
                    }
                    yrsObj[Object.keys(yearsObj[b])] = {
                        signup: signup,
                        redeem: redeem,
                        expired: expired,
                        balance: signup - redeem - expired,
                        totalSignup: totalSignup,
                        totalRedeem: totalRedeem,
                        totalExpired: totalExpired,
                        totalBalance: totalSignup - totalRedeem - totalExpired,
                    }
                }
                this.voucherItems = yrsObj
            }

            this.isSpinnerShow = false
            this.setExportData(this.voucherItems)

            var summaryItem = {}
            for(var k=0; k<this.typeItems.length; k++){
                summaryItem[this.typeItems[k]] = this.getTotal(this.typeItems[k])
            }
            var data = {
                date: this.dateRange,
                summary: summaryItem
            }
            this.$emit('setSummary', data)
        },
        async getVoucherSummary(strFilter){
            let $vm = this;
            let QUERY_STRING = strFilter;
            const url =  this.$api.REPORT_VOUCHER + QUERY_STRING;

            var result = []
            await $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                result = response.data.result
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
            return result;
        },
        getTotal(type){
            var total = 0;
            for(var key in this.voucherItems){
                var item = this.voucherItems[key]
                for(var itemType in item){
                    if(itemType == type){
                        total += item[itemType]
                    }
                }
            }
            return total       
        },
        setExportData(data){
            var outlet = this.filterObj.outletID == "all" ? this.$i18n.t('label.all', {'item': this.$i18n.t('label.outlet')}) : getOutletName(this.filterObj.outletID, JSON.parse(this.$store.state.outlets));
            var strDate = moment(this.filterObj.date.startDate).format(this.$msg.CST.DATE_FORMAT) + " - " + moment(this.filterObj.date.endDate).format(this.$msg.CST.DATE_FORMAT);

            let header = this.$msg.REPORT.HEADER + this.$i18n.t(`subMenu.salon_report_voucher`) + "(" + this.$i18n.messages[this.$i18n.locale].tab.reportCreditTabs[0].text + ")" 
            var exportHeaders = [
                this.$msg.REPORT.HEADER + this.$i18n.t(`subMenu.salon_report_voucher`), 
                this.$i18n.t('table.header.date') + ": " + strDate , 
                this.$i18n.t('table.report_generate') + moment().format(this.$msg.CST.DATE_TIME_24), 
                this.$i18n.t('label.outlet') + ": " + outlet , 
                this.$i18n.t('salon_report.view') + this.$i18n.messages[this.$i18n.locale].tab.reportVoucherSummaryType[3].text,
                " "];
            var exportFileName =  header.split(" ").join("_") + strDate + this.$msg.REPORT.CSV

            var exportData = []
            var i = 0;
            for(var key in data){
                exportData.push({
                    index: i+1,
                    date: key,
                    signup: data[key].signup,
                    redeem: data[key].redeem,
                    expired: data[key].expired,
                    balance: data[key].balance,
                    totalSignup: data[key].totalSignup,
                    totalRedeem: data[key].totalRedeem,
                    totalExpired: data[key].totalExpired,
                    totalBalance: data[key].totalBalance,
                })
                i++;
            }
            exportData.push({
                index: "",
                date: this.$i18n.t('label.total'),
                signup: this.getTotal('signup'),
                redeem: this.getTotal('redeem'),
                expired: this.getTotal('expired'),
                balance: this.getTotal('balance'),
                totalSignup: this.getTotal('totalSignup'),
                totalRedeem: this.getTotal('totalRedeem'),
                totalExpired: this.getTotal('totalExpired'),
                totalBalance: this.getTotal('totalBalance'),
            })

            var exportObj = {
                data: exportData,
                fields: this.exportFields,
                headers: exportHeaders,
                fileName: exportFileName
            }
            
            this.$emit('setExportData', exportObj)
        }
    },
}
</script>
<style scoped>
.border-top-bottom-2{
    border-top-width:  2px !important;
    border-bottom-width:  2px !important;
}
</style>